import { DownOutlineIcon, TopOutlineIcon } from '@carboncopyco/icons';
import { useBoolean } from 'ahooks';
import classNames from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import type React from 'react';
import { Button } from '../Button';
import { TextBase, TextLargeParagraph } from '../Typography';

const transition = {
  type: 'spring',
  stiffness: 800,
  damping: 100,
};

export interface ExpandableBoxProps {
  children: React.ReactNode;
  title: string;
  description?: string;
  leftArrow?: boolean;
}

export const ExpandableBox = ({
  children,
  title,
  description,
  leftArrow,
}: ExpandableBoxProps) => {
  const [hidden, { toggle }] = useBoolean(true);
  return (
    <div className="select-none cursor-pointer">
      <div
        onClick={() => toggle()}
        className={classNames(
          { 'rounded-t-md': !hidden, 'rounded-md': hidden },
          'bg-ds-natural-50 hover:bg-ds-natural-100 p-2.5'
        )}
      >
        <div className="flex justify-between items-center">
          <div className="flex justify-start items-center">
            {leftArrow && (
              <div>
                <Button
                  link
                  icon={hidden ? <DownOutlineIcon /> : <TopOutlineIcon />}
                />
              </div>
            )}
            <div className="flex flex-col">
              <TextLargeParagraph
                label={title}
                color="text-ds-natural-600"
              />
              <TextBase label={description} />
            </div>
          </div>
          {!leftArrow && (
            <div>
              <Button
                link
                icon={hidden ? <DownOutlineIcon /> : <TopOutlineIcon />}
              />
            </div>
          )}
        </div>
      </div>
      <AnimatePresence>
        <motion.div
          initial="hidden"
          animate={hidden ? 'hidden' : 'visible'}
          variants={{
            visible: { opacity: 1, display: 'block' },
            hidden: { opacity: 0, display: 'none' },
          }}
          transition={transition}
          hidden={hidden}
        >
          {children}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};
